import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

import { CommunicationConsent } from "@hubcapp/types";
import updateLead from "../graph-ql/updateLeadAcceptance.graphql";

const useMutationUpdateLead = (
  opts: MutationHookOptions<{
    id: string;
    emailAddress: string;
    salutation?: string;
    firstName?: string;
    lastName?: string;
    mobileNumber?: string;
    address?: {
      line1: string | undefined | null;
      town: string | undefined | null;
      postcode: string | undefined | null;
    };
    dateOfBirth?: Date;
    licenceNumber?: string;
    communication?: CommunicationConsent;
    channel?: string;
  }> = {},
) =>
  useMutation(updateLead, {
    ...opts,
  });

export default useMutationUpdateLead;
